import React from "react";
import {
  About,
  ClientComponent,
  ContactUs,
  Footer,
  OurOffering,
  Project,
  // Service,
  Team,
  Value,
} from "../../components";

const HomePage = () => {
  return (
    <div className="w-full bg-transparent" id="home">
      <Team />
      <div className="border-t border-t-greyBg">
        <div className="bg-primaryBg flex py-8 lg:py-20 w-full justify-center px-4 lg:px-0">
          <div
            className="flex w-full justify-center items-center flex-col gap-8 lg:gap-20 pt-0 lg:pt-12"
            id="service"
          >
            <div className="flex max-w-7xl w-full">
              <div className="py-10 flex w-full lg:py-20">
                <OurOffering />
              </div>
            </div>
            <div className="flex w-full items-center justify-center border-b border-b-[#a0a5e2]">
              {/* <Project /> */}
            </div>
            <div className="flex max-w-7xl w-full pt-10">
              <div className="flex flex-col px-3 lg:px-0 gap-4 lg:gap-8">
                <h1
                  className="text-2xl lg:text-4xl font-bold"
                  data-aos="fade-down"
                  data-aos-duration={2000}
                  data-aos-delay={400}
                >
                  Why Partner with YTC?
                </h1>
                <div className="flex flex-col gap-4 lg:gap-8">
                  <img
                    src="https://i.ibb.co/0C0WC0Z/job-5382501-1920.jpg"
                    alt="job-5382501-1920"
                    className="w-full rounded-md lg:rounded-lg"
                    data-aos="zoom-in-up"
                    data-aos-duration={2000}
                    data-aos-delay={500}
                  />
                  <div className="flex flex-col gap-4 lg:gap-8">
                    <h1
                      className="text-xl lg:text-2xl"
                      data-aos="fade-up"
                      data-aos-duration={1000}
                      data-aos-delay={400}
                    >
                      To thrive in the ever-evolving market landscape, companies
                      must consistently innovate by creating fresh offerings.
                      It's imperative to not only modernize outdated products
                      and platforms but also address the evolving needs of
                      customers. Embedding customer-centricity into product
                      development and delivering innovative solutions are
                      non-negotiable for progress.
                    </h1>
                    <h1
                      className="text-xl lg:text-2xl"
                      data-aos="fade-up"
                      data-aos-duration={1000}
                      data-aos-delay={500}
                    >
                      Effective product design should not only enhance user
                      experience but also contribute to revenue generation and
                      brand enhancement. Achieving this requires synergizing
                      product strategy with technical prowess and digital
                      implementation.
                    </h1>
                    <h1
                      className="text-xl lg:text-2xl"
                      data-aos="fade-up"
                      data-aos-duration={1000}
                      data-aos-delay={600}
                    >
                      Choosing to collaborate with YTC ensures access to
                      streamlined processes that blend creativity, expertise,
                      and passion for product development. Our specialized
                      infrastructure team continuously develops cutting-edge
                      tools for seamless Continuous Integration/Continuous
                      Deployment (CI/CD), automation, analytics, and monitoring.
                      With our comprehensive tooling support, our products are
                      crafted, delivered, and refined with precision.
                    </h1>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className=" bg-primaryBg flex py-10 lg:py-20 w-full justify-center px-4 lg:px-0">
          <div className="flex max-w-6xl w-full lg:pt-12">
            <div className="flex flex-col gap-4 lg:gap-16">
              <h1
                className="text-2xl lg:text-4xl font-bold"
                data-aos="fade-up"
                data-aos-duration={1000}
                data-aos-delay={400}
              >
                Do You Need Product Engineering Services?
              </h1>
              <div className="flex flex-col gap-4 lg:gap-8">
                <img
                  src="https://i.ibb.co/pnJc8Xr/people-1979261.jpg"
                  alt="job-5382501-1920"
                  className="w-full rounded-md lg:rounded-lg"
                  data-aos="zoom-in-down"
                  data-aos-duration={2000}
                  data-aos-delay={400}
                />
                <div className="flex flex-col gap-3 lg:gap-8">
                  <h1
                    className="font-bold text-xl lg:text-3xl text-blue-600"
                    data-aos="fade-up"
                    data-aos-duration={1000}
                    data-aos-delay={400}
                  >
                    Yes, if you aim to:
                  </h1>
                  <h1
                    className="text-lg lg:text-2xl"
                    data-aos="fade-up"
                    data-aos-duration={1000}
                    data-aos-delay={500}
                  >
                    ✅ Continually innovate and build new products to meet
                    evolving customer demands and explore new markets. progress.
                  </h1>
                  <h1
                    className="text-lg lg:text-2xl"
                    data-aos="fade-up"
                    data-aos-duration={1000}
                    data-aos-delay={600}
                  >
                    ✅ Elevate an existing product or platform.
                  </h1>
                  <h1
                    className="text-lg lg:text-2xl"
                    data-aos="fade-up"
                    data-aos-duration={1000}
                    data-aos-delay={700}
                  >
                    ✅ Reduce time-to-market.
                  </h1>
                  <h1
                    className="text-lg lg:text-2xl"
                    data-aos="fade-up"
                    data-aos-duration={1000}
                    data-aos-delay={800}
                  >
                    ✅ Drive transformational value, brand equity and revenue at
                    your organization.
                  </h1>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="px-4 lg:px-0 bg-primaryBg">
          <About />
        </div>
        <Value />
        {/* <div className="px-4 bg-primaryBg lg:px-0"><Service /></div> */}
        <div className="bg-primaryBg px-4 lg:px-0">
          <ClientComponent />
        </div>
        {/* <div><TakeTheNextStep /></div> */}
        <ContactUs />
        <Footer />
      </div>
    </div>
  );
};

export default HomePage;
